import React from 'react';

import { Loading, LoadingContainer } from './styles';

const LoadingFilter = () => (
  <LoadingContainer>
    <Loading />
  </LoadingContainer>
);

export default LoadingFilter;
